/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILdsCurrencyExchangeNoticeData } from './lds-currency-exchange-notice.data';
import { ILdsCurrencyExchangeNoticeProps } from './lds-currency-exchange-notice.props.autogenerated';

export interface ILdsCurrencyExchangeNoticeViewProps extends ILdsCurrencyExchangeNoticeProps<ILdsCurrencyExchangeNoticeData> {}

/**
 *
 * LdsCurrencyExchangeNotice component
 * @extends {React.PureComponent<ILdsCurrencyExchangeNoticeProps<ILdsCurrencyExchangeNoticeData>>}
 */
class LdsCurrencyExchangeNotice extends React.PureComponent<ILdsCurrencyExchangeNoticeProps<ILdsCurrencyExchangeNoticeData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LdsCurrencyExchangeNotice;
